module.exports = __webpack_public_path__ + "img/ICSR_2021.dd7ac8ae.png";